module.exports = __webpack_public_path__ + "img/powerpoint.7649d332.svg";